export default "__VITE_ASSET__BHFAffiI__"